import API_URLS from '../../constants/api-urls';
import { FOLDER_DIRECTORIES } from '../../constants/folder';
import axios from '../../utils/axios';

type CreateFolderArgs = {
    parent_id: null | number;
    title: string;
    type: FOLDER_DIRECTORIES;
    world: string;
};

export const createFolder = (data: CreateFolderArgs) => axios.post(API_URLS.FOLDERS.CREATE, data);
